import React, { ChangeEvent } from 'react';
import { Field, isField } from '@truvity/widget__forms';
import { useFieldError, TextField } from '@truvity/widget__forms-mui-theme';

import { NumericTextFieldWrapperStyled } from './NumericTextFieldWrapper.styled';

export const NumericStringField = (props: Field<number | undefined>) => {
    const { input, typeDescriptor, meta } = props;

    if (!isField(typeDescriptor)) {
        throw new Error(`Incorrect descriptor type: ${input.name}`);
    }

    const error = useFieldError(meta);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const maxLength = typeDescriptor.ui.maxLength || event.target.value.length;
        const value = event.target.value.slice(0, maxLength);

        input.onChange(value);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        // <input type=number /> does not prevent these keys from typing
        const keysAllowedInTypeNumberInput = ['e', '-', '.', ','];
        if (keysAllowedInTypeNumberInput.includes(event.key)) event.preventDefault();
    };

    return (
        <NumericTextFieldWrapperStyled>
            <TextField
                {...error}
                value={input.value}
                onChange={handleChange}
                meta={meta}
                typeDescriptor={typeDescriptor}
                MuiProps={{
                    type: 'number',
                    name: input.name,
                    onBlur: input.onBlur,
                    onKeyDown: handleKeyDown,
                }}
            />
        </NumericTextFieldWrapperStyled>
    );
};
